import { render, staticRenderFns } from "./work-message.vue?vue&type=template&id=f5149104&scoped=true"
import script from "./work-message.vue?vue&type=script&lang=ts"
export * from "./work-message.vue?vue&type=script&lang=ts"
import style0 from "./work-message.vue?vue&type=style&index=0&id=f5149104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5149104",
  null
  
)

export default component.exports